import styles from './index.less';
import goldUrl from '@/assets/user/gold.png';
import { RightOutlined } from '@ant-design/icons';
import showUrl from '@/assets/global/show.png';
import hideUrl from '@/assets/global/hide.png';
import { useEffect, useState, FC } from 'react';
import { history, useModel } from '@umijs/max';

import { useSafeState } from 'ahooks';
import { accountCategoryMap, AccountDetailType } from '@/pages/Mine/interface';
import { Popover } from 'react-vant';
import type { PopoverAction } from 'react-vant/es/popover/PropsType';

interface Action extends PopoverAction {
  value: string;
}

interface AccountInfoProps {
  getAccountInformation: (value: AccountDetailType) => void;
}

const AccountInfo: FC<AccountInfoProps> = (props) => {
  const { getAccountInformation } = props;
  const [show, setShow] = useState<boolean>(true);
  const { accountDetailList } = useModel('useAccount', (model) => ({
    accountDetailList: model.accountDetailList,
  }));
  const [accountInformation, setAccountInformation] =
    useSafeState<AccountDetailType>();
  const [popoverActions, setPopoverActions] = useSafeState<Action[]>([]);

  const handleSelect = (action: PopoverAction & { value: string }) => {
    console.log(action, 'action');
    const data = accountDetailList.find(
      (item) => item.accountCategory === action.value,
    );
    setAccountInformation(data);
  };

  const goToAccountInfo = () => {
    history.push('/accountInformation');
  };

  const toggleShow = () => {
    setShow(!show);
  };

  useEffect(() => {
    if (accountInformation) {
      getAccountInformation(accountInformation);
    }
  }, [accountInformation]);

  useEffect(() => {
    if (accountDetailList && accountDetailList.length > 0) {
      setAccountInformation(accountDetailList[0]);
      setPopoverActions(
        accountDetailList.map((item) => ({
          text: accountCategoryMap[item.accountCategory],
          value: item.accountCategory,
        })),
      );
    }
  }, [accountDetailList]);

  return (
    <div className={styles.container}>
      <div className={styles['user-info']}>
        <Popover
          reference={
            <div className={styles['user']}>
              账户名称：
              {accountInformation?.accountCategory
                ? accountCategoryMap[accountInformation?.accountCategory]
                : ''}
            </div>
          }
          actions={popoverActions}
          onSelect={handleSelect as any}
        />

        <div className={styles['account-action']}>
          <div onClick={goToAccountInfo} className={styles.record}>
            账户明细 <RightOutlined className={styles.icon} />
          </div>
        </div>
      </div>
      <div className={styles['account-info']}>
        <img className={styles.gold} src={goldUrl} alt={'gold'} />
        <p>账户余额￥</p>
        <img
          onClick={toggleShow}
          className={styles.eyes}
          src={show ? showUrl : hideUrl}
          alt={'eyes'}
        />
      </div>
      <div className={styles['account-amount']}>
        {show ? accountInformation?.balance : '****'}
      </div>
    </div>
  );
};
export default AccountInfo;
